// extracted by mini-css-extract-plugin
export default {"barCode":"printBarCode_barCode__ZxM0O"};